import React from 'react';

import MarkerWithInfoWindow from 'modules/google-maps/MarkerWithInfoWindow';
import StopInfoWindow from 'modules/journey/map/StopInfoWindow';

const StopMarkers = ({ stopMarkers }) => {
  return stopMarkers.map(({ icon, latitude, longitude, ...stop }, key) => (
    <MarkerWithInfoWindow
      key={key}
      position={{ lat: latitude, lng: longitude }}
      content={<StopInfoWindow stop={stop} />}
      icon={icon}
    />
  ));
};

export default StopMarkers;
